import { arrayOfProjectTemplateTasks, projectTemplateTask } from "~/schemas/schema.project_template_tasks.jsx";
import * as actionTypes from "~/store/action_types";
import {
  makeGetTaskListIdByProjectTemplateElementIdSelector,
  makeGetTaskListIdByTaskId,
  makeGetTemplateIdByProjectTemplateElementIdSelector,
} from "~/store/selectors/selector.projectTemplateElements.jsx";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchProjectTemplateTaskDependencies = (projectTemplateTaskId) => {
  return {
    types: [
      actionTypes.FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING,
      actionTypes.FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS,
      actionTypes.FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/project-templates/dependencies/tasks/${projectTemplateTaskId}`,
      }),
    payload: {
      projectTemplateTaskId,
      schema: {
        parents: arrayOfProjectTemplateTasks,
        children: arrayOfProjectTemplateTasks,
      },
    },
  };
};

export const fetchProjectTemplateTaskDependenciesSuggestions = (projectTemplateTaskId) => {
  return {
    types: [
      actionTypes.FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_LOADING,
      actionTypes.FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS,
      actionTypes.FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/project-templates/dependencies/tasks/${projectTemplateTaskId}/suggestions`,
      }),
    payload: {
      projectTemplateTaskId,
      schema: arrayOfProjectTemplateTasks,
    },
  };
};

export const deleteProjectTemplateTasksDependency =
  (projectTemplateTaskId, dependencyId, isParent) => (dispatch, getState) => {
    const getProjectIdByTaskId = makeGetTemplateIdByProjectTemplateElementIdSelector();
    const projectTemplateId = getProjectIdByTaskId(getState(), projectTemplateTaskId);
    const getTaskListId = makeGetTaskListIdByTaskId();
    const taskListId = getTaskListId(getState(), dependencyId);
    return dispatch({
      types: [
        actionTypes.DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING,
        actionTypes.DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS,
        actionTypes.DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR,
      ] /* eslint-disable */,
      callAPI: () =>
        fetch({
          /*eslint-enable */
          url: `${Angie.api_url}/project-templates/dependencies/tasks/${projectTemplateTaskId}`,
          method: `put`,
          body: {
            dependency_id: dependencyId,
          },
        }),
      payload: {
        projectTemplateTaskId,
        taskListId,
        projectTemplateId,
        is_parent: isParent,
        dependency_id: dependencyId,
      },
    });
  };

export const createProjectTemplateTasksDependency = (projectTemplateTaskId, attributes) => (dispatch, getState) => {
  const getTaskListIdByTaskId = makeGetTaskListIdByProjectTemplateElementIdSelector();
  const getTemplateIdByTaskId = makeGetTemplateIdByProjectTemplateElementIdSelector();
  const taskListId = getTaskListIdByTaskId(getState(), attributes.dependency_id);
  const templateId = getTemplateIdByTaskId(getState(), projectTemplateTaskId);

  return dispatch({
    types: [
      actionTypes.ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING,
      actionTypes.ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS,
      actionTypes.ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR,
    ] /* eslint-disable */,
    callAPI: () =>
      fetch({
        /*eslint-enable */
        url: `${Angie.api_url}/project-templates/dependencies/tasks/${projectTemplateTaskId}`,
        method: `post`,
        body: { ...attributes },
      }),
    payload: {
      projectTemplateTaskId,
      taskListId,
      templateId,
      ...attributes,
      schema: {
        parent: projectTemplateTask,
        child: projectTemplateTask,
      },
    },
  });
};
